import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SupportVideoPlayerPage } from './support-video-player';

@NgModule({
  declarations: [
    SupportVideoPlayerPage
  ],
  imports: [
    IonicPageModule.forChild(SupportVideoPlayerPage)
  ]
})
export class SupportVideoPlayerPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/support/support-video-player/support-video-player.module.ts